// src/components/SwipeButtons.jsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faHeart } from '@fortawesome/free-solid-svg-icons';

export default function SwipeButtons({ onSwipeLeft, onSwipeRight }) {
  return (
    <div className="flex justify-center gap-12 mt-6 mb-4">
      <button
        onClick={onSwipeLeft}
        className="w-16 h-16 flex items-center justify-center rounded-full bg-white shadow-lg text-red-500 hover:scale-105 active:scale-95 transition-transform"
      >
        <FontAwesomeIcon icon={faXmark} className="text-3xl" />
      </button>

      <button
        onClick={onSwipeRight}
        className="w-16 h-16 flex items-center justify-center rounded-full bg-white shadow-lg text-green-500 hover:scale-105 active:scale-95 transition-transform"
      >
        <FontAwesomeIcon icon={faHeart} className="text-3xl" />
      </button>
    </div>
  );
}